angular.module 'zc.core'

# This is to convert date object with separate date/time properties
# into single jstime object
# example
# date = {
#       date: date in jstime
#       time: minutes of current day
#       date_raw: date as string
#       time_raw: HH:mm as string
# }
#
# after filter returns the date stringified
#
.filter 'dateObjToDate', ($filter) ->
  return (date_obj) ->
    date = null

    if (date_obj and
        date_obj.date and
        (date_obj.time or date_obj.time == 0))
      date = moment(date_obj.date).add(date_obj.time, 'minutes').format()

    return date



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/filters/date_obj_to_date.filter.js.coffee